import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProductsImg from "../../assets/images/bag-img.png";
import MainProductsImg from "../../assets/images/watch.png";
import { Link } from "react-router-dom";
import { GiWatch } from "react-icons/gi";
import { FaArrowRight } from "react-icons/fa";
import Slider from "react-slick";
import { useSelector } from "react-redux";
const Banner = () => {
  const bannerSlider = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    autoplaySpeed: 2000,
  };
  const { token } = useSelector((state) => state.auth);
  const { items } = useSelector((state) => state.products);

  return (
    <section className="homebanner">
      <Container>
        <Row>
          <Col xl={9} lg={8} md={12} sm={12} xs={12}>
            <div className="banner-content">
              <Slider {...bannerSlider}>
                <div className="banner-item">
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div className="banner-title">
                        <div className="banner-subtitle">
                          <GiWatch />
                          <h5>Smart Watch</h5>
                        </div>
                        <h3>Bloomsom Smart Watch</h3>
                        <Link to="#">
                          <span>Shop Now</span> <FaArrowRight />
                        </Link>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mainproduct-img">
                        <img
                          src={MainProductsImg}
                          alt="product_img"
                          loading="lazy"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Slider>
            </div>
          </Col>
          <Col xl={3} lg={4} md={12} sm={12} xs={12}>
            <div className="banner-productcard">
              <img src={ProductsImg} alt="banner_img" loading="lazy" />
              <h4>Leadher Bags</h4>
              {!token ? (
                <Link to="/login" className="productcard-button">
                  Login to View Price
                </Link>
              ) : (
                <h5 className="productcard-price">{items.cost  || ""}</h5>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Banner;
